@if (authority && body && dossier) {
	<div class="container p-3">
		<it-breadcrumb>
			<it-breadcrumb-item
				><a routerLink="/">{{
					"it.navigation.home" | translate
				}}</a></it-breadcrumb-item
			>
			<it-breadcrumb-item
				><a
					routerLink="/dossiers"
					[queryParams]="{ authority: body.id }"
					>{{ body.label["iterlex.currentLanguage" | translate] }}</a
				></it-breadcrumb-item
			>
			<it-breadcrumb-item>
				{{ dossier.title }}
			</it-breadcrumb-item>
		</it-breadcrumb>
	</div>
	<div class="container">
		<div class="d-flex align-items-center gap-2">
			<h1>
				{{ dossier.title }}
			</h1>
			<button
				type="button"
				itButton="link"
				(click)="editDossierModal.toggle()"
			>
				<it-icon
					name="pencil"
					[title]="'it.general.edit' | translate"
				></it-icon>
			</button>
			<button
				type="button"
				itButton="link"
				(click)="archiveDossierModal.show()"
			>
				<it-icon
					name="box"
					[title]="'iterlex.archive' | translate"
				></it-icon>
			</button>
			<app-notifications
				[authority]="authority"
				[body]="body"
				[dossier]="dossier"
			></app-notifications>
			<button
				type="button"
				itButton="primary"
				(click)="graphModal.toggle()"
			>
				{{ "iterlex.graph" | translate }}
			</button>
			<button
				type="button"
				itButton="primary"
				(click)="goToDossierStats()"
			>
				{{ "iterlex.stats" | translate }}
			</button>
		</div>
		<p>
			{{ dossierType?.label?.[("iterlex.currentLanguage" | translate)] }}
			({{ "iterlex.dossier-state-" + dossier.state | translate }}),
			{{ "iterlex.number" | translate }} {{ dossier.number }},
			{{ (dossier.date | date: "d/M/yyyy") ?? dossier.date }}
		</p>
		@if (dossier.metadata.modificationsDestinations) {
			<p>
				{{ "iterlex.modifications-destination" | translate }}:
				{{ dossier.metadata.modificationsDestinations.join(", ") }}
			</p>
		}
	</div>
	<div class="container-fluid phase-tabs">
		<it-tab-container (tabSelected)="changeTab($event)">
			@for (phase of phases; track phase.id) {
				<it-tab-item
					[id]="tabPrefix + phase.id"
					[label]="phase.label['iterlex.currentLanguage' | translate]"
					[active]="phase.id === this.currentPhaseId"
				>
					<app-phase
						[dossier]="dossier"
						[authority]="authority"
						[body]="body"
						[phase]="phase"
						[active]="phase.id === this.currentPhaseId"
						[phaseTabPrefix]="tabPrefix"
						(sendedToStagingAreaEvent)="
							sentToStagingAreaModal.show(); refreshDossier()
						"
					/>
				</it-tab-item>
			}
		</it-tab-container>
	</div>
	<it-modal #editDossierModal size="lg">
		<ng-container modalTitle>{{
			"it.general.edit" | translate
		}}</ng-container>
		<form
			#editDossierForm="ngForm"
			(ngSubmit)="onEditDossierSubmit(editDossierForm)"
		>
			<it-input
				type="text"
				name="title"
				ngModel
				required
				[label]="'iterlex.title' | translate"
				[ngModel]="dossier.title"
			></it-input>
			<button
				itButton="primary"
				type="submit"
				[disabled]="!editDossierForm.valid"
				data-bs-dismiss="modal"
			>
				{{ "it.general.save" | translate }}
			</button>
		</form>
		<ng-container footer><span></span></ng-container>
	</it-modal>
	<it-modal #sentToStagingAreaModal alertModal="true">
		<ng-container modalTitle>{{
			"iterlex.sent-to-staging-area" | translate
		}}</ng-container>
		<p>
			{{
				"iterlex.sent-to-staging-area-description"
					| translate: { name: dossier.title }
			}}
		</p>
	</it-modal>
	<it-modal
		#archiveDossierModal="itModal"
		closeButton="false"
		popconfirm="true"
	>
		<ng-container modalTitle>{{
			"iterlex.archive-dossier-confirm" | translate
		}}</ng-container>
		<p>
			{{
				"iterlex.archive-dossier-confirm-description"
					| translate: { name: dossier.title }
			}}
		</p>
		<ng-container footer>
			<button
				itButton="primary"
				type="button"
				data-bs-dismiss="modal"
				(click)="markDossierAsArchived()"
			>
				{{ "iterlex.archive" | translate }}
			</button>
			<button
				itButton="outline-secondary"
				type="button"
				data-bs-dismiss="modal"
			>
				{{ "iterlex.cancel" | translate }}
			</button>
		</ng-container>
	</it-modal>
	<app-dossier-graph
		#graphModal
		[dossier]="dossier"
		[authority]="authority"
		[body]="body"
		[phases]="phases"
	></app-dossier-graph>
}
